import React, { useState, useEffect } from "react";
import styles from "./index.module.scss";
import { Link } from "react-router-dom";
import { getCategoriesOnlyLv1 } from "../../services/api";
import Layout from "../../layouts/User";
import { Col, Row } from "antd";

export type Props = {};

const breadcrumbs = [
  {
    text: "หน้าแรก",
    path: "/",
  },
  {
    text: "หมวดหมู่สินค้า",
    path: "/product-categories",
  },
];

const Register: React.FC<Props> = (props) => {
  const [categories, setCategories] = useState([]);

  const getApi = async () => {
    setCategories(await getCategoriesOnlyLv1());
  };

  useEffect(() => {
    getApi();
  }, []);

  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div className={styles.wrapper}>
          <h1 className={styles.header}>ค้นหาตามหมวดหมู่</h1>
          <Row gutter={[16, 16]}>
            {categories.map((item: any, index: number) => (
              <Col xs={12} sm={8} lg={6} key={index}>
                <Link to={`/product-categories/detail?id=${item._id}`}>
                  <div className={styles.catColumn} style={{ backgroundImage: `url(${item.imageUrl})` }}>
                    <div className={styles.text}>{item.name}</div>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
      </Layout>
    </>
  );
};
export default Register;
